import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Container, Table, Card, Row, Col, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Loading from './Loading';

const Dashboard = ({token}) => {
    const { user } = useAuth0();
    const [accounts, setAccounts] = useState([]);
    const [roles, setRoles] = useState([]);
    const [groupedRoles, setGroupedRoles] = useState({});
    const [loading, setLoading] = useState(false);

    const baseURL = "https://095uu10x5k.execute-api.us-east-1.amazonaws.com/production"

    useEffect(() => {
        setLoading(true);
        if (!token) {
            return;
        }

        fetch(`${baseURL}/users/${user.nickname}`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
        .then(response => {
            if(!response.ok) { throw response }
            return response.json()
        })
        .then(data => {
            setAccounts(data ? data : []);
            fetch(`${baseURL}/roles`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            .then(roleResponse => {
                if(!roleResponse.ok) { throw roleResponse }
                return roleResponse.json();
            })
            .then(roleData => {
                const processedRoles = roleData.filter(role => role.status === "processed");
                setRoles(processedRoles);

                const roleGroups = processedRoles.reduce((acc, role) => {
                    const { account: { accountName } } = role;
                    if (!acc[accountName]) {
                        acc[accountName] = [];
                    }
                    acc[accountName].push(role);
                    return acc;
                }, {});
                
                setGroupedRoles(roleGroups);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error:', error);
                setRoles([]);
                setLoading(false);
            });
        })
        .catch(error => {
            console.error('Error:', error)
            setAccounts([]);
            setLoading(false);
        });
    }, [token]);

    if (loading) {
        return <Loading />
    }

    return (
        <Container className="py-4">
            <div className="page-header">
                <h1>Dashboard</h1>
                <p className="text-muted">Manage your ephemeral IAM roles and accounts</p>
            </div>
            
            <Card className="mb-4 shadow-sm">
                <Card.Header className="bg-white">
                    <h2 className="section-title mb-0">Currently Provisioned Ephemeral IAM Roles</h2>
                </Card.Header>
                <Card.Body className="p-0">
                    <Table responsive hover className="mb-0">
                        <thead>
                            <tr>
                                <th>Account Name</th>
                                <th>Role Name</th>
                                <th>Destination Policy Services</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(groupedRoles).length > 0 ? (
                                Object.keys(groupedRoles).map((accountName, i) =>
                                    groupedRoles[accountName].map((role, index) => (
                                        <tr key={index}>
                                            <td>{accountName}</td>
                                            <td>
                                                <Link to={`/roles/${role.id}`} state={{role: role}} className="fw-medium">
                                                    {role.roleName}
                                                </Link>
                                            </td>
                                            <td>
                                                {role.destinationPolicyServices.map(service => (
                                                    <span key={service} className="service-tag me-1 mb-1">
                                                        {service}
                                                    </span>
                                                ))}
                                            </td>
                                        </tr>
                                    ))
                                )
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center py-4 text-muted">
                                        No ephemeral IAM roles provisioned yet
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
            
            <Card className="shadow-sm">
                <Card.Header className="bg-white">
                    <h2 className="section-title mb-0">AWS Accounts</h2>
                </Card.Header>
                <Card.Body className="p-0">
                    <Table responsive hover className="mb-0">
                        <thead>
                            <tr>
                                <th>Account Name</th>
                                <th>Account ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {accounts.length > 0 ? (
                                accounts.map((account, index) => (
                                    <tr key={index}>
                                        <td>
                                            <Link to={`/accounts/${account.id}`} state={{name: account.accountName}} className="fw-medium">
                                                {account.accountName}
                                            </Link>
                                        </td>
                                        <td>
                                            <Badge bg="light" text="dark" className="border">{account.id}</Badge>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2" className="text-center py-4 text-muted">
                                        You do not have access to any accounts that have the necessary JIT role
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default Dashboard;